import { Box, Stack } from "@mui/material";
import ContactPhoneIcon from "@/modules/lead-page/new/components/contact-phone-icon";
import ContactWhatsappIcon from "@/modules/lead-page/new/components/contact-whatsap-icon";

interface Props {
  phoneNumber: string | undefined;
  whatsappUsername?: string;
  doNotCall?: boolean;
  children?: React.ReactNode;
}

export default function ActionsCompact({
  phoneNumber,
  whatsappUsername,
  doNotCall,
  children,
}: Props) {
  return (
    <Stack direction="row" spacing={1}>
      {!doNotCall && (
        <>
          {" "}
          <ContactWhatsappIcon
            phoneNumber={phoneNumber}
            username={whatsappUsername}
          />
          <ContactPhoneIcon phoneNumber={phoneNumber} />
        </>
      )}
      <Box sx={{ alignSelf: "flex-start", flexShrink: 0 }}>{children}</Box>
    </Stack>
  );
}
